import { createSelector, createSlice } from "@reduxjs/toolkit";
import { apiCallBegan, apiCallFailed } from "./api";

const slice = createSlice({
    name: "clients",
    initialState: {
        list: [],
        loading: false,
        lastFetch: null,
        addedStatus: false,
        appAddedStatus: false,
        clientApi: null,
        clientApp: [],
        clientList: []
    },
    reducers: {
        clientAdded: (clients, action) => {
            clients.addedStatus = action.payload;
        },
        clientsReceived: (clients, action) => {
            clients.list = action.payload;
        },
        clientApiAdded: (clients, action) => {
            clients.addedStatus = action.payload;
        },
        clientAppAdded: (clients, action) => {
            clients.appAddedStatus = action.payload;
        },
        clientApiReceived: (clients, action) => {
            clients.clientApi = action.payload;
        },
        clientAppReceived: (clients, action) => {
            clients.clientApp = action.payload;
        },
        clientListReceived: (clients, action) => {
            clients.clientList = action.payload;
        },
    }
});

export const { clientAdded, clientsReceived,
    clientApiAdded, clientApiReceived, clientListReceived,
    clientAppAdded, clientAppReceived } = slice.actions;
export default slice.reducer;

const addClient = "client/addClient";
const allClient = "client/allClients";
const addClientApi = "client/addClientApi";
const getClientApi = "client/getClientApi";
const getClientList = "client/getClientList";
const addClientApp = "client/addClientApp";
const getClientApp = "client/getClientApp";

export const addNewClient = data => apiCallBegan({
    url: addClient,
    method: "post",
    data: data,
    onSuccess: clientAdded.type,
});

export const addNewClientApi = data => apiCallBegan({
    url: addClientApi,
    method: "post",
    data: data,
    onSuccess: clientApiAdded.type,
});

export const addNewClientApp = data => apiCallBegan({
    url: addClientApp,
    method: "post",
    data: data,
    onSuccess: clientAppAdded.type,
});

export const loadAllClients = (pageSize, pageIndex) => apiCallBegan({
    url: allClient + "?pageSize=" + pageSize + "&pageIndex=" + pageIndex,
    onSuccess: clientsReceived.type
});

export const loadClientApi = id => apiCallBegan({
    url: getClientApi + "?id=" + id,
    onSuccess: clientApiReceived.type
});

export const loadClientApp = id => apiCallBegan({
    url: getClientApp + "?id=" + id,
    onSuccess: clientAppReceived.type
});

export const loadClientList = () => apiCallBegan({
    url: getClientList,
    onSuccess: clientListReceived.type
});

export const getAllClients = createSelector(
    state => state.entities.clients,
    clients => clients.list
)

export const getClientConfigApi = createSelector(
    state => state.entities.clients,
    clients => clients.clientApi
)

export const getClientAddedStatus = createSelector(
    state => state.entities.clients,
    clients => clients.addedStatus
)

export const getClientsList = createSelector(
    state => state.entities.clients,
    clients => clients.clientList
)

export const getClientsApps = createSelector(
    state => state.entities.clients,
    clients => clients.clientApp
)